













import { Vue, Component } from "vue-property-decorator";
import { MToast } from "@ulaval/modul-components";
import store, { modules } from "../store";

@Component({ components: { MToast } })
export default class MessageErreur extends Vue {
  get messageErreur(): string {
    return store.state.applicatif.messageErreur;
  }

  get afficherMessageErreur(): boolean {
    return this.messageErreur !== "";
  }

  private initialiserMessageErreur(): void {
    store.commit(modules.applicatif.mutations.modifierMessageErreur.name, "");
  }
}
